import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./authSlice";
const Slices = combineReducers({
  auth: authSlice,
});
export default Slices;